import { bl_fi_mst_ecomsync_item_syncing_history_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class FinancialEcomsyncItemSyncingHistoryContainerModel extends BaseContainerModel {
  bl_fi_mst_ecomsync_item_syncing_history: bl_fi_mst_ecomsync_item_syncing_history_RowClass = new bl_fi_mst_ecomsync_item_syncing_history_RowClass();
}

